// extracted by mini-css-extract-plugin
module.exports = {"lockIcon":"album-badges-lockicon_lockIcon__zcT8P"};